export default __webpack_public_path__ + "static/media/mlp-card-1.c2961fb8.png";